import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!-- {{routable/google-auth model=model}} --}}",{ moduleName: "mewe/templates/google-auth.hbs" })